import * as React from "react";
import {ReactNode, useEffect, useRef, useCallback} from "react";

export interface ISliderProps {
    header: string;
    content: ReactNode;
    display: boolean;
    hideSlider: () => void;
}

export const SliderComponent: React.FunctionComponent<ISliderProps> = (props: ISliderProps) => {
    const sliderTabRef = useRef<HTMLDivElement>(null);
    const closeButtonRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (props.display && sliderTabRef.current) {
            sliderTabRef.current.scrollTop = 0;
        }
        if (props.display && closeButtonRef.current) {
            closeButtonRef.current.focus();
        }
    }, [props.display]);

    const handleKeyDown = useCallback((e: React.KeyboardEvent) => {
        if (e.key === "Escape") {
            props.hideSlider();
        }
    }, [props.hideSlider]);

    const getMenuClass = () => {
        return ((props.display) ? "slider__tab-shown" : "slider__tab-hidden");
    };

    return <div className="slider__container" data-testid="slider__container" onKeyDown={handleKeyDown}>
                {props.display && <div className="menu__overlay" onClick={props.hideSlider} data-testid="menu__overlay"/>}
                <div
                    id="slider__tab"
                    className={getMenuClass()}
                    data-testid="slider__tab"
                    ref={sliderTabRef}
                    role="dialog"
                    aria-modal={props.display ? "true" : undefined}
                    aria-labelledby="slider__tab-heading"
                >
                    <div className="slider__tab-header-container">
                        <span className="slider__tab-heading" id="slider__tab-heading">{props.header}</span>
                        <button
                            type="button"
                            className="slider__tab-close-btn"
                            id="slider__tab-close"
                            onClick={props.hideSlider}
                            ref={closeButtonRef}
                            data-testid="slider__close"
                            aria-label="Close panel"
                        >
                            <i className="fa-regular fa-x" aria-hidden="true" />
                        </button>
                    </div>
                    <div className="slider__tab-text" data-testid="slider__tab-text">
                        {props.content}
                    </div>
                </div>
           </div>;
};
